import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSkillSaveSuggestionShown.meta';

export const useTrackSkillSaveSuggestionShown = () => {
  const { track } = useAnalyticsUtilities();

  const trackSkillSaveSuggestionShown = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackSkillSaveSuggestionShown };
};
